// Recent Donors Vue Component
// Replaces the liquid paginate/loop with Vue + cached data

// Add the donor styles that were in donation.liquid
const donorStyles = `
  .quote:has(.donor) {
    max-height: fit-content !important;
  }

  .carousel__slide:has(.donor) {
    min-width: 300px !important;
  }

  .quote__content.donor {
    background: #ffffff;
  }

  .donor-card-wrapper {
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    row-gap: 1.2rem;
  }

  .donor-card-details {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  .donor-avatar {
    display: flex;
    justify-content: center;
    align-items: center;
    height: auto;
    width: 64px;
    aspect-ratio: 1/1;
    border-radius: 1337px;
    overflow: hidden;
  }

  .fundraiser-avatar {
    width: 24px;
    height: 24px;
    object-fit: cover;
    border-radius: 1337px;
    border: 1px solid var(--gsc-foreground-color-100);
  }

  .fundraiser-name {
    font-size: 1.2rem;
    font-weight: 500;
  }

  .fundraiser-donation {
    font-size: 1rem;
    font-weight: 500;
    text-transform: uppercase;
    margin-top: 0.2rem;
    text-align: center;
  }

  .fundraiser-details {
    text-decoration: none;
    border: 1px solid var(--gsc-foreground-color-100);
    border-radius: 1337px;
    padding: 0.4rem 0.6rem 0.4rem 0.4rem;
    display: flex;
    align-items: center;
    gap: 0.6rem;
    margin-top: 1.2rem
    line-height: 1.1;
  }

  .carousel__slide:not(:has(.donor-avatar > img)):nth-of-type(5n+1) .donor-avatar {
    background: rgba(98, 214, 222, 1);
  }

  .carousel__slide:not(:has(.donor-avatar > img)):nth-of-type(5n+2) .donor-avatar {
    background: rgba(253, 185, 185, 1);
  }

  .carousel__slide:not(:has(.donor-avatar > img)):nth-of-type(5n+3) .donor-avatar {
    background: rgba(103, 217, 253, 1);
  }

  .carousel__slide:not(:has(.donor-avatar > img)):nth-of-type(5n+4) .donor-avatar {
    background: rgba(255, 100, 34, 1);
  }
  
  .carousel__slide:not(:has(.donor-avatar > img)):nth-of-type(5n+5) .donor-avatar {
    background: rgba(255, 184, 0, 1);
  }

  .carousel__slide:has(.donor-avatar > img):nth-of-type(5n+1) .donor-avatar {
    box-shadow: 0 0 0 1px rgba(98, 214, 222, 1);
  }

  .carousel__slide:has(.donor-avatar > img):nth-of-type(5n+2) .donor-avatar {
    box-shadow: 0 0 0 1px rgba(253, 185, 185, 1);
  }

  .carousel__slide:has(.donor-avatar > img):nth-of-type(5n+3) .donor-avatar {
    box-shadow: 0 0 0 1px rgba(103, 217, 253, 1);
  }

  .carousel__slide:has(.donor-avatar > img):nth-of-type(5n+4) .donor-avatar {
    box-shadow: 0 0 0 1px rgba(255, 100, 34, 1);
  }

  .carousel__slide:has(.donor-avatar > img):nth-of-type(5n+5) .donor-avatar {
    box-shadow: 0 0 0 1px rgba(255, 184, 0, 1);
  }

  .quote__author-name {
    font-family: var(--obviously-font);
    font-variation-settings: var(--bold-font);
    font-size: var(--gsc-fz-10);
    line-height: var(--gsc-lh-6);
    font-weight: unset;
    text-align: center;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: antialiased;
    text-rendering: optimizelegibility;
    text-wrap: balance;
  }

  .donor-initals {
    font-family: var(--obviously-font);
    font-variation-settings: var(--bold-font);
    font-size: calc(var(--gsc-heading-5-font-size)*0.9);
    line-height: calc(var(--gsc-heading-5-line-height)*0.9);
    font-weight: unset;
    margin-bottom: -0.6rem;
    padding: 120px;
    --gsc-heading-line-height: var(--gsc-heading-6-line-height);
    --gsc-heading-font-size: var(--gsc-heading-6-font-size);
  }

  .donor-behalf {
    font-size: 0.8rem;
    font-weight: 400;
    color: var(--gsc-foreground-color-200);
    margin-top: 0.2rem;
  }

  .donor-messaging {
    text-align: center;
    text-wrap: balance;
    margin-top: 0.4rem;
  }

  .donor-tribute {
    background: linear-gradient(to right, #b48c38, #ffdb74, #987018, #ffdb74, #956816);
    font-weight: 700;
    background-size: 200% auto;
    color: #000;
    background-clip: text;
    -webkit-text-fill-color: transparent;
    animation: animatedGradient 4s linear infinite;
    font-size: var(--gsc-body-font-size-s);
    line-height: var(--gsc-body-line-height-xxs);
  }

  @keyframes animatedGradient {
    to {
      background-position: 200% center;
    }
  }

  .donor-date {
    font-size: var(--gsc-fz-14);
    line-height: var(--gsc-lh-6);
    margin-top: 0.8rem;
    margin-bottom: 0.8rem;
  }

  .donor-amount {
    color: #20c008;
    text-align: center;
    width: 100%;
    display: block;
  }

  .donor-avatar img {
    width: 100%;
    height: 100%;
    object-fit: contain;
    padding: 0;
  }

  .quote {
    justify-content: space-evenly;
  }

  .quote__content.donor {
    justify-content: center;
  }

  .quote-text {
    margin-bottom: -0.3rem;
  }

  .donor-comment {
    font-size: var(--gsc-body-font-size-s);
    line-height: var(--gsc-body-line-height-xs);
  }

  .quote__content {
    padding: 1.6rem 1.8rem;
  }

  .gift-aid-text {
    color: var(--gsc-accent-color);
  }

  .gift-aid-logo {
    display: inline-block;
    width: 60px;
    height: 20px;
    margin-left: 4px;
    vertical-align: middle;
  }
`;

// Inject the styles
if (!document.getElementById('recent-donors-styles')) {
  const styleElement = document.createElement('style');
  styleElement.id = 'recent-donors-styles';
  styleElement.textContent = donorStyles;
  document.head.appendChild(styleElement);
}

const RecentDonors = {
  props: {
    limit: {
      type: String,
      default: '15'
    },
    slideClass: {
      type: String,
      default: 'carousel__slide'
    },
    // Pass through donation component props
    donationClass: {
      type: String,
      default: ''
    },
    textVariant: {
      type: String,
      default: 'medium'
    },
    isInsideSidebar: {
      type: Boolean,
      default: true
    },
    withBackground: {
      type: Boolean,
      default: false
    },
    slideType: {
      type: String,
      default: 'horizontal'
    },
    desktopColumns: {
      type: String,
      default: '3'
    },
    showRating: {
      type: Boolean,
      default: false
    }
  },

  setup(props) {
    const { computed, onMounted, watch, nextTick } = Vue;
    const { donors, loading, error, loadDonors } = window.donorStore;

    // Get recent donors (sorted by date, newest first, limited)
    const recentDonors = computed(() => {
      const sortedDonors = [...donors.value].sort((a, b) => {
        const dateA = new Date(a.date);
        const dateB = new Date(b.date);
        return dateB - dateA; // newest first
      });
      
      return sortedDonors.slice(0, parseInt(props.limit));
    });

    // Track if carousel has been initialized to prevent multiple calls
    let carouselInitialized = false;

    // Function to reinitialize carousel
    const reinitializeCarousel = () => {
      if (carouselInitialized) return;
      
      nextTick(() => {
        setTimeout(() => {
          // Find the carousel component that contains this Vue instance
          const carouselElements = document.querySelectorAll('carousel-component');
          carouselElements.forEach(carousel => {
            // Check if this carousel contains our Vue component
            if (carousel.querySelector('.recent-donors-vue')) {
              // Check if carousel has slides before initializing
              const slides = carousel.querySelectorAll('.carousel__slide');
              if (slides.length > 0) {
                // console.log('Found carousel with', slides.length, 'Vue donor slides, reinitializing...');
                
                // Restore autoplay settings
                const vueAutoplayMode = carousel.getAttribute('data-vue-autoplay-mode');
                const vueAutoplayInterval = carousel.getAttribute('data-vue-autoplay-interval');
                
                if (vueAutoplayMode) {
                  carousel.setAttribute('data-autoplay-mode', vueAutoplayMode);
                  carousel.removeAttribute('data-vue-autoplay-mode');
                }
                if (vueAutoplayInterval) {
                  carousel.setAttribute('data-autoplay-interval', vueAutoplayInterval);
                  carousel.removeAttribute('data-vue-autoplay-interval');
                }
                
                // Trigger embla reinit if the carousel has an embla instance
                if (carousel.embla) {
                  // console.log('Reinitializing embla carousel with Vue content');
                  carousel.embla.reInit();
                  carouselInitialized = true;
                } else {
                  // console.log('No embla instance found, triggering carousel initialization');
                  // Trigger carousel initialization
                  if (carousel.initialize) {
                    carousel.initialize();
                    carouselInitialized = true;
                  }
                }
              } else {
                console.log('No slides found yet, skipping carousel initialization');
              }
            }
          });
        }, 300); // Increased timeout to ensure Vue rendering is complete
      });
    };

    // Watch for changes in donors data and reinitialize carousel
    watch(recentDonors, (newDonors) => {
      if (newDonors && newDonors.length > 0 && !carouselInitialized) {
        reinitializeCarousel();
      }
    });

    // Initialize data loading
    onMounted(() => {
      loadDonors().then(() => {
        // Wait for Vue to render the content, then initialize carousel
        nextTick(() => {
          // Use a longer delay to ensure embla carousel components are fully loaded
          setTimeout(() => {
            reinitializeCarousel();
          }, 500);
        });
      });
    });

    // Helper functions (matching the liquid template logic)
    const getInitials = (name) => {
      if (!name) return '';
      return name.split(' ').map(word => word.charAt(0)).join('').toUpperCase();
    };

    const formatDate = (dateString) => {
      const date = new Date(dateString);
      return date.toLocaleDateString('en-GB', { 
        day: 'numeric', 
        month: 'short', 
        year: 'numeric' 
      });
    };

    const formatMoney = (amount) => {
      return new Intl.NumberFormat('en-GB', {
        style: 'currency',
        currency: 'GBP'
      }).format(amount);
    };

    const getAvatarHtml = (donor) => {
      if (donor.anonymous === 'true') {
        return { type: 'text', content: 'A', alt: 'Anonymous' };
      } else if (donor.avatar) {
        return { type: 'image', content: donor.avatar, alt: donor.name || 'Donor' };
      } else if (donor.company) {
        const parts = donor.company.split(' ');
        const initials = (parts[0]?.charAt(0) || '') + (parts[1]?.charAt(0) || '');
        return { type: 'text', content: initials.toUpperCase(), alt: donor.company };
      } else {
        return { type: 'text', content: getInitials(donor.name), alt: donor.name || 'Donor' };
      }
    };

    const getDisplayName = (donor) => {
      if (donor.anonymous === 'true') {
        return { name: 'Anonymous', onBehalf: null };
      } else if (donor.company) {
        return { name: donor.company, onBehalf: donor.name };
      } else {
        return { name: donor.name || 'Anonymous', onBehalf: null };
      }
    };

    const getGiftAidInfo = (donor) => {
      if (donor.gift_aid === 'true') {
        const donationDate = new Date(donor.date);
        const april16_2025 = new Date('2025-04-16');
        
        if (donationDate >= april16_2025) {
          const giftAidAmount = (parseFloat(donor.amount) * 0.25).toFixed(2);
          return { show: true, amount: giftAidAmount };
        }
      }
      return { show: false, amount: 0 };
    };

    const getTributeComment = (donor) => {
      const result = { tribute: null, comment: null };
      
      if (donor.tribute) {
        const dedicatedPrefix = donor.tribute.match(/^(Memory|memory|Dedicated|dedicated|For|for)/) ? '' : 'Dedicated to ';
        result.tribute = dedicatedPrefix + donor.tribute;
      }
      
      if (donor.comment) {
        result.comment = donor.comment
          .replace(/profanity/g, '')
          .replace(/https?:\/\//g, '');
      }
      
      return result;
    };

    return {
      recentDonors,
      loading,
      error,
      formatMoney,
      formatDate,
      getAvatarHtml,
      getDisplayName,
      getGiftAidInfo,
      getTributeComment,
      giftAidLogoUrl: window.giftAidLogoUrl
    };
  },

  template: `
    <template v-if="loading && recentDonors.length === 0">
      <div class="loading-state carousel__slide">
        Loading recent donors...
      </div>
    </template>
    <template v-else-if="error">
      <div class="error-state carousel__slide">
        Error loading donors: {{ error }}
      </div>
    </template>
    <template v-else>
      <div 
        v-for="donor in recentDonors" 
        :key="donor.id || donor.name + donor.date"
        :class="slideClass"
      >
        <!-- Match the exact structure of the original donation snippet -->
        <quote-component :class="'quote' + (donationClass ? ' ' + donationClass : '') + (withBackground ? ' quote--with-background' : ' quote--without-background')">
          <max-lines-component :class="'quote__content donor' + (!withBackground ? ' quote__content--without-right-padding quote__content--without-aside-paddings' : '')">            
            <div class='donor-card-wrapper'>
              <div class='donor-avatar'>
                <img v-if="getAvatarHtml(donor).type === 'image'" 
                     :src="getAvatarHtml(donor).content" 
                     :alt="getAvatarHtml(donor).alt" 
                     loading="lazy">
                <span v-else class='donor-initals'>{{ getAvatarHtml(donor).content }}</span>
              </div>
              
              <div class='donor-card-details'>
                <div class='quote__author-name'>
                  {{ getDisplayName(donor).name }}
                  <span v-if="getDisplayName(donor).onBehalf" class='donor-behalf'>
                    on behalf of {{ getDisplayName(donor).onBehalf }}
                  </span>
                </div>
                
                <div :class="'quote__text quote__text--' + textVariant + (isInsideSidebar ? '' : ' quote__text--truncate')">
                  <span class='donor-amount'>
                    {{ formatMoney(parseFloat(donor.amount)) }}
                    <template v-if="getGiftAidInfo(donor).show">
                      + <span class="gift-aid-text">£{{ getGiftAidInfo(donor).amount }}</span>
                      <span class="gift-aid-logo">
                        <img :src="giftAidLogoUrl" alt="Gift Aid" width="60" height="20">
                      </span>
                    </template>
                  </span>
                </div>
                
                <div v-if="getTributeComment(donor).tribute || getTributeComment(donor).comment" class='donor-messaging'>
                  <p v-if="getTributeComment(donor).tribute" class='donor-tribute'>
                    {{ getTributeComment(donor).tribute }}
                  </p>
                  <q v-if="getTributeComment(donor).comment" class='donor-comment'>
                    {{ getTributeComment(donor).comment }}
                  </q>
                </div>
                
                <p class='donor-date'>
                  {{ formatDate(donor.date) }}
                </p>

                <a v-if="donor.fundraiser_link" class="fundraiser-details" :href="donor.fundraiser_link" target="_blank">
                  <img v-if="donor.fundraiser_picture" class="fundraiser-avatar" :src="donor.fundraiser_picture" width="64px" height="64px" alt="{{ donor.fundraiser }} Profile Picture" />
                  <img v-else class="fundraiser-avatar" :src="'https://cdn.shopify.com/s/files/1/0795/4556/5514/files/default-fundraiser-avatar.jpg?v=1738760684'" alt="{{ donor.fundraiser }} Profile Picture" />
                  <span class="fundraiser-name">{{ donor.fundraiser }}</span>
                </a>
                <span v-if="donor.fundraiser_link" class="fundraiser-donation">{{ donor.campaign }} Fundraiser</span>
              </div>
            </div>
          </max-lines-component>
        </quote-component>
      </div>
    </template>
  `
};

// Auto-mount recent donors components
const initializeRecentDonors = () => {
  const { createApp } = Vue;
  const recentDonorsElements = document.querySelectorAll('.recent-donors-vue');
  
  recentDonorsElements.forEach(element => {
    // Skip if already initialized
    if (element.hasAttribute('data-vue-initialized')) return;
    
    // Find the parent carousel component and mark it as having Vue content
    const carouselComponent = element.closest('carousel-component');
    if (carouselComponent) {
      carouselComponent.setAttribute('data-has-vue-content', 'true');
    }
    
    const props = {
      limit: element.getAttribute('data-limit') || '15',
      slideClass: element.getAttribute('data-slide-class') || 'carousel__slide',
      donationClass: element.getAttribute('data-donation-class') || '',
      textVariant: element.getAttribute('data-text-variant') || 'medium',
      isInsideSidebar: element.getAttribute('data-inside-sidebar') === 'true',
      withBackground: element.getAttribute('data-with-background') === 'true',
      slideType: element.getAttribute('data-slide-type') || 'horizontal',
      desktopColumns: element.getAttribute('data-desktop-columns') || '3',
      showRating: element.getAttribute('data-show-rating') === 'true'
    };
    
    element.setAttribute('data-vue-initialized', 'true');
    createApp(RecentDonors, props).mount(element);
  });
};

// Prevent autoplay on carousels with Vue content before they initialize
const disableAutoplayOnVueCarousels = () => {
  const carousels = document.querySelectorAll('carousel-component');
  carousels.forEach(carousel => {
    if (carousel.querySelector('.recent-donors-vue')) {
      const autoplayMode = carousel.getAttribute('data-autoplay-mode');
      const autoplayInterval = carousel.getAttribute('data-autoplay-interval');
      
      if (autoplayMode) {
        carousel.removeAttribute('data-autoplay-mode');
        carousel.setAttribute('data-vue-autoplay-mode', autoplayMode);
      }
      if (autoplayInterval) {
        carousel.removeAttribute('data-autoplay-interval');
        carousel.setAttribute('data-vue-autoplay-interval', autoplayInterval);
      }
    }
  });
};

// Run this as early as possible
disableAutoplayOnVueCarousels();

// Initialize on DOM ready
document.addEventListener('DOMContentLoaded', () => {
  // Disable autoplay on Vue carousels first
  disableAutoplayOnVueCarousels();
  // Then initialize Vue components
  initializeRecentDonors();
});

// Also initialize on window load as a fallback
window.addEventListener('load', () => {
  // Small delay to ensure all carousel components are loaded
  setTimeout(() => {
    disableAutoplayOnVueCarousels();
    initializeRecentDonors();
  }, 100);
});